export default function StatCard({ icon, value, title, description, tone = 'text-coral' }) {
  return (
    <div className="space-y-2">
      <div className={tone}>{icon}</div>
      <div className={`text-3xl font-extrabold ${tone}`}>{value}</div>
      <div className="text-sm font-semibold text-slate-700">{title}</div>
      <p className="max-w-[170px] text-sm leading-6 text-slate-500">{description}</p>
    </div>
  )
}
